import { IPlugin, PluginStore } from 'react-pluggable';
import FixcenterFooter from './components/FixcenterFooter/FixcenterFooter';

class SetFixcenterFooterPlugin implements IPlugin {
    pluginStore!: PluginStore;

    getPluginName(): string {
        return 'SetFixcenterFooter@1.0.0';
    }
    getDependencies(): string[] {
        return [];
    }
    init(pluginStore: PluginStore): void {
        this.pluginStore = pluginStore;
    }
    activate(): void {
        this.pluginStore.executeFunction('Renderer.add', 'page:fixcenterFooter', () => (
            <FixcenterFooter></FixcenterFooter>
        ));
    }
    deactivate(): void {}
}

export default SetFixcenterFooterPlugin;
